import React from 'react';
import { Link } from 'react-router-dom';
import styles from './links-col.module.scss';

function LinksCol(props: any) {
  return (
    <div className={styles.col + " col-lg-3 col-md-6 m-auto mb-5"}>
      <div className={styles.header}>
        <h3><i className={"fa fa-" + props.icon} /> {props.title}</h3>
      </div>
      <div className={styles.body}>
        <ul className={styles.links}>
          {props.links.map((link: { link: string, title: string }, index: number) => (
            <li key={'link' + index}><Link to={link.link}>{link.title}</Link></li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default LinksCol;
